import styled from 'styled-components';

export const AuthorBlock = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;

  small {
    ${({ badge }) => !badge && 'padding-top: 3px'};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.fontL};

    a {
      color: ${({ theme }) => theme.linkColor};
    }
  }

  strong {
    a {
      display: inline-block;
      color: currentColor;

      &:first-letter {
        text-transform: uppercase;
      }

      &:hover {
        color: ${({ theme }) => theme.mainColor};
      }
    }
  }
`;
